document.addEventListener('DOMContentLoaded', function() {
  function openUniversalPianoLinks() {
    document.querySelectorAll('a[href]').forEach(function(link) {
      if (link.href.includes('universalpiano') && !link.target) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  }

  // Try immediately
  openUniversalPianoLinks();

  // Watch for future changes (for dynamic menus)
  const observer = new MutationObserver(openUniversalPianoLinks);
  observer.observe(document.body, { childList: true, subtree: true });
});
